import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslate } from 'react-redux-multilingual'

import * as actions from '../../../store/actions'

import Aux from '../../../hoc/Auxiliary/Auxiliary'
import Card from '../../../components/UI/Card/Card'
import CardBody from '../../../components/UI/Card/Body/Body'
import CardHeader from '../../../components/UI/Card/Header/Header'

import Alert from '../../../components/Alert/Alert'

import FilterModal from '../../../components/FilterModal/FilterModal'

import { updateFilterOptions, clearFilterOptionValues, updateObject } from '../../../helpers/utils'

import FullWidthTabs from '../../../components/UI/Tabs/Tabs'
import ActionBar from '../../../components/ActionBar/ActionBar'

import IndexPageContent from '../../../components/PageContent/ForceRank/IndexContent/IndexPageContent'
import ForceRankPageContent from '../../../components/PageContent/ForceRank/ForceRankContent/ForceRankPageContent'

import PleaseFilter from '../../../components/PleaseFilter/PleaseFilter'
import Spinner from '../../../components/UI/Spinner/Spinner'
import PageInfo from '../../../components/PageInfo/PageInfo'

class ForceRank extends Component {
  state = {
    filtered: false,
    data: [],
    filterData: [],
    tab: [
      { label: this.props.translate('IndexCalculateTab'), key: 'index_calculation' },
      { label: this.props.translate('ForceRankTab'), key: 'force_rank' }
    ],
    currentTabIndex: 0,
    currentTab: 'index_calculation',
    filter: {},

    filterModalOpen: false,

    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        },
        required: true
      }
    },

    filterOptions: {
      companyFilterOptions: null,
      formFilterOptions: null,
      orgFilterOptions: null
    }
  }

  componentDidMount() {
    this.props.fetchAppraisalTypes()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.appraisalType !== this.props.appraisalType) {
      this.props.fetchFilterOptions({
        appraisal_type_id: this.props.appraisalType?.appraisal_type_id
      })
    }
  }

  componentWillUnmount() {
    this.clearFilter()
  }

  static getDerivedStateFromProps(props, state) {
    if (props.filterOptions.companyFilterOptions !== state.filterOptions.companyFilterOptions) {
      const companyFilter = state.filterControls.company_id
      const updateFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select Company'
      )
      return {
        filterControls: updateObject(state.filterControls, { company_id: updateFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }

    if (props.filterOptions.formFilterOptions !== state.filterOptions.formFilterOptions) {
      const formFilter = state.filterControls.form_id
      const updateFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )
      return {
        filterControls: updateObject(state.filterControls, { form_id: updateFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }

    if (props.filterOptions.orgFilterOptions !== state.filterOptions.orgFilterOptions) {
      const orgFilter = state.filterControls.org_id
      const updateFilterItem = updateFilterOptions(
        props.filterOptions.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )
      return {
        filterControls: updateObject(state.filterControls, { org_id: updateFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          orgFilterOptions: props.filterOptions.orgFilterOptions
        }
      }
    }

    return {
      filterControls: {
        ...state.filterControls
      },
      filterOptions: {
        ...state.filterOptions,
        companyFilterOptions: props.filterOptions.companyFilterOptions
      }
    }
  }

  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter
    })
  }
  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }
  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }
  tabChangeHandler = (event, tabIndex) => {
    let tabKey = null
    switch (tabIndex) {
      case 0:
        tabKey = 'index_calculation'
        break
      case 1:
        tabKey = 'force_rank'
        break

      default:
        break
    }
    this.setState({ currentTab: tabKey, currentTabIndex: tabIndex })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    const updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })
    const appraisalTypeId = this.props.appraisalType?.appraisal_type_id
    const filterOptions = {
      appraisal_type_id: appraisalTypeId,
      company_id: updatedFilterControls.company_id?.value?.value,
      org_id: updatedFilterControls.org_id?.value?.value
    }

    if (itemKey === 'company_id') {
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchFormOptions(filterOptions)
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = (event, page) => {
    let param = {
      company_id: this.state.filterControls.company_id.value.value,
      org_id: this.state.filterControls.org_id.value.value,
      form_id: this.state.filterControls.form_id.value.value,
      page: page,
      perPage: this.props.pagination?.perPage ? this.props.pagination?.perPage : 10
    }

    this.setState({
      filtered: true
    })

    // this.props.fetchForceRankFilter(param)
    this.props.fetchForceRankGrade()
    this.props.fetchAdjust(param)
    this.closeFilterModal()
  }
  render() {
    let tabContent = [
      {
        key: 'index_calculation',
        display: (
          <IndexPageContent
            adjustData={this.props.adjustData}
            gradeData={this.props.gradeData}
            loading={this.props.loading}
            pagination={this.props.pagination}
            filterData={this.props.filterData}
            filterControls={this.state.filterControls}
            fetchForceRankFilter={param => {
              this.props.fetchForceRankFilter(param)
            }}
            fetchAdjust={param => {
              this.props.fetchAdjust(param)
            }}
          />
        )
      },
      {
        key: 'force_rank',
        display: (
          <ForceRankPageContent
            data={this.props.data}
            adjustData={this.props.adjustData}
            gradeData={this.props.gradeData}
            filterControls={this.state.filterControls}
            filterData={this.props.filterData}
            loading={this.props.loading}
            createForceRank={data => {
              this.props.createForceRank(data)
            }}
            fetchForceRankList={param => {
              this.props.fetchForceRankList(param)
            }}
          />
        )
      }
    ]

    let content = <PleaseFilter />

    if (this.state.filtered === true) {
      if (this.props.filterLoading === true) {
        content = <Spinner />
      } else {
        content = (
          <FullWidthTabs
            variant={'fullWidth'}
            tabs={this.state.tab}
            tabChanged={this.tabChangeHandler}
            tabContents={tabContent}
            currentTabIndex={this.state.currentTabIndex}
          />
        )
      }
    }

    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, event) => this.filterChangedHandler(itemKey, event)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Card>
          <CardHeader>
            <ActionBar
              filtering={this.openFilterModal}
              show={['filter']}
              leftContent={<PageInfo pageTranslateKey={'forceRank'} />}
            />
          </CardHeader>
          <CardBody>{content}</CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  const appraisalType = state.individualAssignment.appraisalTypes.find(item => {
    return item.appraisal_type_code === 'APT02'
  })

  return {
    appraisalType: appraisalType,
    pagination: state.forceRank.pagination,
    // filtered: state.forceRank.filtered,
    filterLoadingQueue: state.forceRank.filterLoadingQueue,
    filterData: state.forceRank.filterData,
    filterLoading: state.forceRank.filterLoading,
    // loading: state.forceRank.loading,
    pageLoading: state.forceRank.filterLoading || state.forceRank.appraisalTypes.length === 0,
    filterOptions: {
      companyFilterOptions: state.forceRank.filterCompanies,
      formFilterOptions: state.forceRank.filterForms,
      orgFilterOptions: state.forceRank.filterOrgs
    },
    data: state.forceRank.data,
    adjustData: state.forceRank.adjustData,
    gradeData: state.forceRank.gradeData
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAdjust: param => dispatch(actions.fetchAdjust(param)),
    fetchForceRankList: param => dispatch(actions.fetchForceRankList(param)),
    createForceRank: data => dispatch(actions.createForceRank(data)),
    fetchForceRankGrade: () => dispatch(actions.fetchGradeOptions()),
    fetchForceRankFilter: filterOptions => dispatch(actions.fetchForceRankFilter(filterOptions)),
    fireAlert: alertOption => {
      dispatch(actions.enqueueSnackbar(alertOption))
    },
    fetchAppraisalTypes: () => {
      dispatch(actions.fetchAppraisalTypeOptions())
    },
    fetchFilterOptions: filterOptions => {
      dispatch(actions.fetchCompanyOptionsForAppraisal(filterOptions))
    },
    fetchFormOptions: filterOptions => {
      dispatch(actions.fetchFormOptionsForAppraisal(filterOptions))
    },
    fetchOrgOptions: filterOptions => {
      dispatch(actions.fetchForcedOrganizationOptionsForAppraisal(filterOptions))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ForceRank))
